// extracted by mini-css-extract-plugin
export var buttonContainer = "_9w-1";
export var fontSizeSelect = "_9w-3";
export var formatSelect = "_9w-2";
export var formats = "_9w-4";
export var hidden = "_9w-5";
export var icon = "_9w-6";
export var select = "_9w-0";